// import dayjs from 'dayjs';

import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import client from 'src/utils/client';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useDateUpdate } from 'src/utils/helper';

const WidgetLottoCheck = ({ eventDataLayer }) => {
  const dispatch = useDispatch();
  const [dateData, setDateData] = useState(null);
  const [selectdate, setSelectdate] = useState(null);

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = data => {
    const lottos = [data.lotto1, data.lotto2, data.lotto3].filter(check => check.length === 6);

    if (lottos.length === 0) return;
    setSelectdate(data.date);
    client.get(`/api/v1.0/lottory/${data.date}`, { params: { lottos } }).then(async res => {
      await dispatch({ type: 'LOTTO_DATA', result: res });
    });
  };

  useEffect(async () => {
    const res = await client.get('/api/v1.0/lottory/selectdate');
    setDateData(res);
  }, []);

  // console.log(watch('date', 'lotto1', 'lotto2', 'lotto3'));

  return (
    <div className='widget-lottery-check'>
      <h3>ตรวจผลสลากกินแบ่งรัฐบาล</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='form-group'>
          <label>งวดวันที่</label>
          <select
            name='date'
            defaultValue=''
            ref={register}
            className='form-control'
            onChange={e => {
              setSelectdate(e.target.value);
            }}
          >
            {dateData === null ? null : (
              <>
                {dateData.map((item, index) => (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
        <div className='form-group'>
          <input name='lotto1' className='form-control' ref={register({ pattern: /^\d{6,}/i })} maxLength='6' placeholder='กรอกเลขสลาก ใบที่ 1' />
          {errors.lotto1 && <span>กรุณากรอกเป็นตัวเลข จำนวน 6 หลัก</span>}
        </div>
        <div className='form-group'>
          <input name='lotto2' className='form-control' ref={register({ pattern: /^\d{6,}/i })} maxLength='6' placeholder='กรอกเลขสลาก ใบที่ 2' />
          {errors.lotto2 && <span>กรุณากรอกเป็นตัวเลข จำนวน 6 หลัก</span>}
        </div>
        <div className='form-group'>
          <input name='lotto3' className='form-control' ref={register({ pattern: /^\d{6,}/i })} maxLength='6' placeholder='กรอกเลขสลาก ใบที่ 3' />
          {errors.lotto3 && <span>กรุณากรอกเป็นตัวเลข จำนวน 6 หลัก</span>}
        </div>
        <button
          type='submit'
          className='custom-btn'
          aria-label='Lotto Submit'
          //! DATALAYER
          onClick={() => sendDataLayerGlobal({ ...eventDataLayer, data: { title: useDateUpdate(selectdate), heading: 'ตรวจสลากฯ ของคุณ' } })}
        >
          ตรวจสลากฯ ของคุณ
        </button>
      </form>
    </div>
  );
};

export default WidgetLottoCheck;
